import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@workspace/ui/components/dialog'
import { TERMS_COPY } from '../copy/terms-copy'
import { TermsAgreement } from './terms-agreement'

// Shown over the app to an onboarded account until the current terms and privacy versions are recorded. There is no
// close button, and Escape or a click outside do nothing, so accepting is the only way forward.
export function TermsAcceptanceDialog() {
  const keepOpen = (event: Event) => event.preventDefault()

  return (
    <Dialog open>
      <DialogContent
        showCloseButton={false}
        onEscapeKeyDown={keepOpen}
        onPointerDownOutside={keepOpen}
        onInteractOutside={keepOpen}
      >
        <DialogHeader>
          <DialogTitle>{TERMS_COPY.title}</DialogTitle>
          <DialogDescription>{TERMS_COPY.intro}</DialogDescription>
        </DialogHeader>
        <TermsAgreement />
      </DialogContent>
    </Dialog>
  )
}
